import { render } from "./PaymentsWrapper.vue?vue&type=template&id=32e3e907&scoped=true"
import script from "./PaymentsWrapper.vue?vue&type=script&lang=js"
export * from "./PaymentsWrapper.vue?vue&type=script&lang=js"

import "./PaymentsWrapper.vue?vue&type=style&index=0&id=32e3e907&lang=css"
import "./PaymentsWrapper.vue?vue&type=style&index=1&id=32e3e907&scoped=true&lang=css"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e3e907"]])

export default __exports__